import { Injectable, Provider } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { mergeMap } from 'rxjs/operators';

const salesDemoApiWhitelist = [
  '/dashboard/v1/recentBenefits',
  '/dashboard/v1/recentClaims',
  '/dashboard/v1/recentUpdates',
  '/flag/v1/benefits',
  '/flag/v1/claims',
  '/patient/search/v1/individuals',
  '/patient/benefits/v1/benefits/5BOSKLSOOZLEPPGQVSZ73se49lZ7o0dos10ZGSBEOLSBLSPKOVPZEEEQPSVZOGPGLEKGZ702Zx74pZLGLGPLPLZq',
  '/patient/benefits/v1/benefits/GLPSQSLLSZLGEGGQOKZ2010jZz3l20119deZQVOLQSLGZLLVVLVLLZQVESSSBBZyba7Zyba7ZLGLGPLPLZq',
  '/patient/benefits/v1/benefits/LLGPBPELZLGPKGQKKZi3l0eZjwx07j9ZQQLKLOLOPELGQQBKSQQLKLOLOPEZqZGEVLLOQBPZx9d4Zx9d4ZLGLGPLGVZq',
  '/patient/benefits/v1/benefits/5OBBSLVEQZLOPEGQQVZ81see3ls0Zp0t3ZOSLQQLSBGGPGSPKZEPGPESBZGOSLLSEVBZ702ZxpodZLGLGPLPLZq',
  '/patient/benefits/v1/benefits/GLKGPEPGGZGGLPGQSLZps7o304Zoslj40ZPGOQLGQKLZLLSPSOGEZGSQQLLEGVZyba7Zyba7ZLQLGPLGQZGLGVPLGQ',
  '/patient/benefits/v1/benefits/5LGKQSEPOZLQLPGQSLZp04sdd3Zlw1dbw1eo9ZVKGVBLGPOGOSEGQZEPLOPQSZEQBSQSLPZ702Z2le7ZLGLGPLPLZq',
  '/patient/benefits/v1/benefits/5GGLVOOEOZLOPLGQOPZ40syoZ73le5ZEQLGVLELGOKLOSVZPBSSLOLZOEOQVPKZ702Z2le7ZLGLGPLGBZq',
  '/patient/benefits/v1/benefits/5KLKBVLPBZLBLGGQOQZ10l5Zdo3oZVQLSPLBEQBVBSSPZPBSSVGBZOOQBPVSOZ702Zb20lZLVPKPLGEZq',
  '/patient/benefits/v1/benefits/LLOPLLBEZLBGBGQVLZ43510lZdpseoXowlyZBGPEELLOELLGPPOQZ7KSVKGKZOGLKLSQGZ78oZ78oZLGLGPLPLZq',
  '/patient/dental/v1/benefits/5LGKQSEPOZLQLPGQSLZp04sdd3Zlw1dbw1eo9ZVKGVBLGPOGOSEGQZEPLOPQSZEQBSQSLPZ702Z2le7ZLGLGPLPLZq',
  '/patient/dental/v1/benefits/5GGLVOOEOZLOPLGQOPZ40syoZ73le5ZEQLGVLELGOKLOSVZPBSSLOLZOEOQVPKZ702Z2le7ZLGLGPLGBZq',
  '/patient/dental/v1/benefits/5KLKBVLPBZLBLGGQOQZ10l5Zdo3oZVQLSPLBEQBVBSSPZPBSSVGBZOOQBPVSOZ702Zb20lZLVPKPLGEZq',
  '/patient/dental/v1/benefits/LLOPLLBEZLBGBGQVLZ43510lZdpseoXowlyZBGPEELLOELLGPPOQZ7KSVKGKZOGLKLSQGZ78oZ78oZLGLGPLPLZq',
  '/claims/v1/search/1',
  '/claims/v1/7681900123456',
  '/claims/v1/422190712345',
  '/claims/v1/9421905123456',
  '/claims/v1/685191512345',
  '/claims/v1/9432011123456',
  '/claims/v1/E20113608222',
  '/claims/v1/E2007068333',
  '/claims/v1/E20063611111',
  '/claims/v1/E2006378555',
  '/claims/v1/E20070684444',
  '/claims/v1/S20127622666',
  '/claims/reconsideration/v1',
  '/attachments/v1',
  '/profile/v2/tin/123456789/provider',
  '/profile/v2/tin/987654321/provider',
  '/report/v2/search/ddar/1',
  '/report/v2/remittance/summary-data',
  '/report/v2/remittance/amount',
  '/report/v2/remittance/tracking',
  '/finance/v1/eftUpdateMedical',
  '/precert/v1/GLPSQSLLSZLGEGGQOKZ2010jZz3l20119deZQVOLQSLGZLLVVLVLLZQVESSSBBZyba7Zyba7ZLGLGPLPLZq',
  '/precert/v1/5BOSKLSOOZLEPPGQVSZ73se49lZ7o0dos10ZGSBEOLSBLSPKOVPZEEEQPSVZOGPGLEKGZ702Zx74pZLGLGPLPLZq',
  '/precert/v1/IP0033248633',
  '/precert/v1/IP0033248634',
  '/patient/locator/v1/individuals',
  '/reconsideration/medical/v1',
  '/reconsideration/dental/v1',
  '/prv/secure',
];

@Injectable({
  providedIn: 'root',
})
export class SalesDemoInterceptor implements HttpInterceptor {
  constructor(private authFacade: AuthFacade) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): any {
    return this.authFacade.isSalesDemoUser$.pipe(
      mergeMap((isSalesDemo) => {
        if (!isSalesDemo) {
          return next.handle(request);
        }
        if (
          salesDemoApiWhitelist.some((u) => request.urlWithParams.includes(u))
        ) {
          return next.handle(
            request.clone({
              url: request.url
                .replace('/chcp', '/chcp/demo')
                .replace('/prv/secure', '/prv/secure/demo'),
            }),
          );
        }

        return next.handle(request);
      }),
    );
  }
}

export function salesDemoProviders(enabled: boolean): Provider[] {
  return enabled
    ? [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SalesDemoInterceptor,
          multi: true,
        },
      ]
    : [];
}
